import { ChannelSchema } from "@redotech/redo-marketplace-common/channels";
import { productFamilyIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const unpublishProductFamilies = {
  name: "unpublishProductFamilies" as const,
  input: z.object({
    productFamilyIds: z.array(productFamilyIdFormat.schema).min(1),
    channel: ChannelSchema,
  }),

  output: z.object({
    results: z.array(
      z.object({
        productFamilyId: productFamilyIdFormat.schema,
        success: z.boolean(),
        error: z.string().optional(),
      }),
    ),
  }),
};
